import { combineReducers } from 'redux';
import createReducer from 'utils/createReducer';
import {
  LOGIN,
  GOOGLE_LOGIN,
  LOGIN_SUCCESS,
  LOGIN_FAILURE,
  LOGOUT,
  SET_SESSION_PERMISSION,
} from 'state/actionTypes';
import store from 'store';

import {
  STORE_KEY_REMEMBER_TOKEN,
  STORE_KEY_USER_INFO,
} from 'state/session/constants';

const getCurrentUserFromStore = () => {
  const rememberToken = store.get(STORE_KEY_REMEMBER_TOKEN);
  const userInfo = store.get(STORE_KEY_USER_INFO);
  let currentUser;
  try {
    currentUser = JSON.parse(userInfo);
  } catch (ex) {
    currentUser = null;
  }
  if (!rememberToken || !currentUser) {
    return null;
  }
  return currentUser;
};

const handleLoginSuccess = (state, { payload }) => {
  store.set(STORE_KEY_USER_INFO, JSON.stringify(payload.user));
  store.set(STORE_KEY_REMEMBER_TOKEN, payload.token);
  return payload.user;
};

const handleLogout = () => {
  store.remove(STORE_KEY_USER_INFO);
  store.remove(STORE_KEY_REMEMBER_TOKEN);
  return null;
};

const currentUser = createReducer(getCurrentUserFromStore(), {
  [LOGIN]: () => null,
  [GOOGLE_LOGIN]: () => null,
  [LOGIN_SUCCESS]: handleLoginSuccess,
  [LOGIN_FAILURE]: () => null,
  [LOGOUT]: handleLogout,
});

const isLoggingIn = createReducer(false, {
  [LOGIN]: () => true,
  [GOOGLE_LOGIN]: () => true,
  [LOGIN_SUCCESS]: () => false,
  [LOGIN_FAILURE]: () => false,
});

const permissionInitialState = {
  roles: [],
  permissions: new Map(),
  resources: [], // processes to resources[path][method]
  pages: new Set(), // directly page.pattern
};

const permission = createReducer(permissionInitialState, {
  [SET_SESSION_PERMISSION]: (state, { payload }) => payload.permission,
});

export default combineReducers({
  currentUser,
  isLoggingIn,
  permission,
});
